import React from 'react';
import { useRouteError } from 'react-router';
import { PageError } from '../PageError';
import { getErrorMessage, isPrintToPdfMode, signalPdfError } from '../utils';
/**
 * Handles rendering global application errors by routing to appropriate error pages,
 * and signals PDF rendering errors when in print-to-PDF mode.
 *
 * @param {GlobalErrorProps} props - The props for the GlobalError component.
 * @param {'not-found' | 'access-issue'} [props.type] - The type of error page to display.
 * @param {string} [props.description] - Optional error description to show on the error page.
 *
 * @returns {JSX.Element} A component rendering the appropriate error view based on the error type or caught error.
 */
export const GlobalError = (props) => {
    const error = useRouteError();
    React.useEffect(() => {
        if (isPrintToPdfMode()) {
            signalPdfError(getErrorMessage(error));
        }
    }, [error]);
    switch (props.type) {
        case 'not-found':
            return React.createElement(PageError, Object.assign({}, props));
        case 'access-issue':
            return React.createElement(PageError, Object.assign({}, props));
        default:
            console.error(error);
            return React.createElement(PageError, Object.assign({ error: error }, props));
    }
};
